import { CurrencyOptions } from '../../../../contexts/CurrencyContext';
import { getDefaultFilterOptions } from '../default';

const COLLECTION = {
  type: 'checkbox',
  title: 'Collection',
  labels: ['Genesis', 'Apocalypse'],
};

const PACKS = {
  type: 'checkbox',
  title: 'Packs',
  labels: [
    'Amateur',
    'Survivor',
    'Assassin',
    'Zombie Killer',
    'Rookie',
    'Veteran',
    'Commander',
  ],
};

const CHAIN = {
  type: 'checkbox',
  title: 'Chain',
  labels: ['Ethereum'],
};

// const PERKS = {
//   type: 'checkbox',
//   title: 'Perks',
//   labels: ['Diet Sprint', 'Macho Dew', `Dr. Helper`, `Reload Rootbeer`],
// };

// const SKINS = {
//   type: 'checkbox',
//   title: 'Skins',
//   withSearch: true,
//   variant: 'skins',
//   labels: [
//     'gold',
//     'iridescent',
//     'safari',
//     'caution',
//     'hunt',
//     'desert',
//     'mooncrash',
//     'steampunk',
//     'vandal',
//     'myth',
//     'octopus',
//     'corsair',
//     'ice',
//     'puncher',
//     'diy',
//     'toxic',
//     'strike',
//     'primal',
//     'lava',
//     'flames',
//     'justice',
//     'flow',
//     'trace',
//     'cards',
//     'kitty',
//     'chopper',
//     'memories',
//     'explode',
//     'celt',
//     'holiday',
//     'old glory',
//     'neon',
//     'anodized',
//     'camouflage',
//     'alert',
//     'pursuit',
//     'rhyno',
//     'cleaner',
//     'skull',
//     'basic',
//   ],
// };

// const WEAPONS = {
//   type: 'checkbox',
//   title: 'Weapons',
//   withSearch: true,
//   labels: [
//     'Combat Knife',
//     'M1911',
//     'Double Barrel Shotgun',
//     'MP5',
//     'AKM',
//     'F1',
//     'M1A',
//     'Revolver',
//     'RPG',
//     'R870 Shotgun',
//     'Fire Axe',
//     'Wave Gun',
//     'Hunting Rifle',
//     'Baseball Bat',
//     'Crossbow',
//     'Grenades',
//   ],
// };

export function getUndeadBlocksFilterOptions(currencyOptions: CurrencyOptions) {
  return [
    ...getDefaultFilterOptions(currencyOptions),
    CHAIN,
    COLLECTION,
    PACKS,
    // TODO: we need to fix undead blocks item attributes
    // before these will work.
    // SKINS,
    // WEAPONS,
    // PERKS,
  ];
}
